import {useMutation, UseMutationResult, useQuery, useQueryClient, UseQueryResult} from '@tanstack/react-query';
import type {AxiosError} from 'axios';
import {IPresentationMeta} from '../../../incase-domain/presentation';
import {patchPresentation} from '../../../service/presentation';
import {IFetchRoom} from '../../../incase-domain/rooms/room.editor';
import {fetchRoomsForPresentation} from '../../../service/room.service';
import {QUERY_KEYS} from '../../../utils/queryKeys';

type PatchPresentationVariables = {
    presentationId: string;
    patch: IPresentationMeta;
};

export const usePatchPresentation = (onSuccess?: () => void): UseMutationResult<void, AxiosError, PatchPresentationVariables> => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({presentationId, patch}) => patchPresentation(presentationId, patch),
        onSuccess: async () => {
            await queryClient.invalidateQueries({queryKey: QUERY_KEYS.presentation.lists()});
            onSuccess?.();
        },
    });
};

export const useRoomsForPresentation = (presentationId: string): UseQueryResult<IFetchRoom[], AxiosError> => {
    return useQuery({
        queryKey: QUERY_KEYS.roomsForPresentation.detail(presentationId),
        queryFn: () => fetchRoomsForPresentation(presentationId),
        keepPreviousData: true,
        enabled: !!presentationId,
        refetchOnMount: 'always',
    });
};
